

$(document).ready(function () {

    //article
    var moreContent = $('#why-more-content')
    var btnShowMore = $('#btn-show-more')
    var btnShowLess = $('#btn-show-less')
    var scrollContainer = $('html, body')
    btnShowMore.click(function () {
        // var scrollTop = scrollContainer.scrollTop()
        moreContent.slideDown({
            progress: function(_, progress) {
                scrollDynamic(moreContent.offset().top, progress)
            }
        });
        btnShowMore.css('display', 'none')
        // scrollContainer.scrollTop(scrollTop).animate({ scrollTop: $(document).height() }, 1000);

    })
    btnShowLess.click(function () {
        moreContent.slideUp("slow");
        btnShowMore.css('display', 'block')
    })

    $('#enrich-people-btn').click(function () {
        $('#enrich-people-btn').css('display', 'none');
        $('#enrich-people-content').slideDown({
            progress: function(_, progress) {
                var tabTop = $('.tabs.group').offset().top
                scrollDynamic(tabTop, progress)
            }
        });
        $('#enrich-people-less').css('display', 'block');
    })

    $('#enrich-people-less').click(function () {
        $('#enrich-people-less').css('display', 'none')
        $('#enrich-people-content').slideUp("slow");
        setTimeout(function () { $('#enrich-people-btn').css('display', 'block')},1000)   
    })

    $('#enrich-planet-btn').click(function () {
        $('#enrich-planet-btn').css('display', 'none')
        $('#enrich-planet-content').slideDown({
            progress: function(_, progress) {
                var tabTop = $('.tabs.group').offset().top
                scrollDynamic(tabTop, progress)
            }
        });
        $('#enrich-planet-less').css('display', 'block')
    })

    $('#enrich-planet-less').click(function () {
        $('#enrich-planet-less').css('display', 'none')
        $('#enrich-planet-content').slideUp("slow");
        setTimeout(function () { $('#enrich-planet-btn').css('display', 'block') }, 1000)   
    })

    $('#empower-btn').click(function () {
        $('#empower-btn').css('display', 'none')
        $('#empower-content').slideDown({
            progress: function(_, progress) {
                var tabTop = $('.tabs.group').offset().top
                scrollDynamic(tabTop, progress)
            }
        });
        $('#empower-less').css('display', 'block')
    })

    $('#empower-less').click(function () {
        $('#empower-less').css('display', 'none')
        $('#empower-content').slideUp("slow");
        setTimeout(function () { $('#empower-btn').css('display', 'block') }, 1000)   
    })

    $('#inspire-btn').click(function () {
        $('#inspire-btn').css('display', 'none')
        $('#inspire-content').slideDown({
            progress: function(_, progress) {
                var tabTop = $('.tabs.group').offset().top
                scrollDynamic(tabTop, progress)
            }
        });
        $('#inspire-less').css('display', 'block')
    })

    $('#inspire-less').click(function () {
        $('#inspire-less').css('display', 'none')
        $('#inspire-content').slideUp("slow");
        setTimeout(function () { $('#inspire-btn').css('display', 'block') }, 1000)   

    })

    // tabs
    var tabs = $(".tabs li a");
  
    $("#content-container>div").hide();
    $("#content-container>div").first().show();

    tabs.click(function (e) {
       e.preventDefault();
        keepNotScroll(() => {
            var content = this.hash.replace('/', '');
            tabs.removeClass("active");
            $(this).addClass("active");
            $("#content-container>div").hide();
            $(content).fadeIn(200);
        })
    });

    function scrollToSection(id1, id2, time) {
        id1.click(function () {
            scrollContainer.animate({
                scrollTop: id2.offset().top
            }, { duration: time, easing: "swing" });
            return false;
        });
    } 
    scrollToSection($("#reward-program"), $("#enrich-people"), 500);
    scrollToSection($("#section-people"), $("#enrich-people"),500);
    scrollToSection($("#section-planet"), $("#enrich-planet"),800);
    scrollToSection($("#section-empower"), $("#empower"),1100);
    scrollToSection($("#section-inspire"), $("#inspire"),1400);



});

// poster frame click event
$(document).on('click', '.js-videoPoster', function (ev) {
    ev.preventDefault();
    var $poster = $(this);
    var $wrapper = $poster.closest('.js-videoWrapper');
    videoPlay($wrapper);
});

// play the targeted video (and hide the poster frame)
function videoPlay($wrapper) {
    var $iframe = $wrapper.find('.js-videoIframe');
    var src = $iframe.data('src');
    // hide poster
    $wrapper.addClass('videoWrapperActive');
    // add iframe src in, starting the video
    $iframe.attr('src', src);
}

// stop the targeted/all videos (and re-instate the poster frames)
function videoStop($wrapper) {
    // if we're stopping all videos on page
    if (!$wrapper) {
        var $wrapper = $('.js-videoWrapper');
        var $iframe = $('.js-videoIframe');
        // if we're stopping a particular video
    } else {
        var $iframe = $wrapper.find('.js-videoIframe');
    }
    // reveal poster
    $wrapper.removeClass('videoWrapperActive');
    // remove youtube link, stopping the video from playing in the background
    $iframe.attr('src', '');
}

function scrollDynamic(targetTop, progress) {
    var scrollTop = document.scrollingElement.scrollTop;
    var disFromTop = targetTop - scrollTop;
    document.scrollingElement.scrollBy(0, disFromTop * progress);
}

function keepNotScroll(action) {
    var scrollTop = document.scrollingElement.scrollTop;
    action();
    document.scrollingElement.scrollTop = scrollTop;
}

